import {
  Button,
  createStyles,
  Dialog,
  Theme,
  WithStyles,
  withStyles,
  AppBar,
  CssBaseline,
  Toolbar,
  Typography,
  DialogContent,
  ThemeProvider,
} from "@material-ui/core";
import deepOrange from "@material-ui/core/colors/deepOrange";
import * as React from "react";
import CloseIcon from "@material-ui/icons/Close";
import { defaultTheme } from "../utils/theme";
const drawerWidth = "30%";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    tabRoot: {
      flexGrow: 1,
    },
    appBar: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
    img: {
      margin: "auto",
      display: "block",
      maxWidth: "80%",
      maxHeight: "80%",
    },
    extendedIcon: {
      marginRight: 1,
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    drawerPaper: {
      marginTop: 64,
      width: drawerWidth,
    },
    image: {
      width: 128,
      height: 128,
    },
    media: {
      height: 200,
      width: 300,
      padding: 10,
      alignSelf: "center",
    },
    drawer: {
      [theme.breakpoints.up("sm")]: {
        width: drawerWidth,
        flexShrink: 0,
      },
    },
    fab: {
      position: "fixed",
      zIndex: 100,
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    section3: {
      margin: theme.spacing(3, 3, 3),
    },
    chip: {
      margin: theme.spacing(0.5),
      color: theme.palette.getContrastText(deepOrange[500]),
    },
    imageTitle: {
      position: "relative",
      padding: `${theme.spacing(2)}px ${theme.spacing(4)}px ${
        theme.spacing(1) + 6
      }px`,
    },
    imageMarked: {
      height: 3,
      width: 18,
      backgroundColor: theme.palette.common.white,
      position: "absolute",
      bottom: -2,
      left: "calc(50% - 9px)",
      transition: theme.transitions.create("opacity"),
    },
    signChip: {
      padding: 5,
      margin: 5,
      width: 120,
      height: 44,
    },
    imageButton: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: theme.palette.common.white,
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    content: {
      marginLeft: "30%",
      flexGrow: 1,
      backgroundColor: theme.palette.background.default,
      padding: theme.spacing(3),
    },
  });
interface Props extends WithStyles<typeof styles> {
  open: any;
  renderStatisticTable: any;
  handleClose: any;
  graphObject: any;
}
class GraphDetailsDialogV2 extends React.Component<Props> {
  state = {};

  componentDidMount = () => {};

  componentDidUpdate(prevProps: any, prevState: any) {}
  renderGraphs = () => {
    // if (
    //   this.props.graphObject &&
    //   this.props.graphObject.graphData &&
    //   this.props.graphObject.graph &&
    //   this.props.graphObject.graph.title
    // ) {
    //   const data = this.props.graphObject.graphData;
    //   const graphName = this.props.graphObject.graph.title;
    //   data.sort(
    //     (a: any, b: any) => moment(a.date).unix() - moment(b.date).unix()
    //   );
    //   switch (graphName) {
    //     case GRAPHS.QUESTIONNAIRE:
    //       return <BarGraphComponent graphData={data} />;
    //     case GRAPHS.TEMPERATURE_MEASUREMENT:
    //       let tempData = DataConverter.convertToLineChartsData(data);
    //       return (
    //         <LineGraphComponent
    //           graphData={tempData}
    //           graph={"normal"}
    //           yLabel={"Number of Persons"}
    //           xLabel={"Temperature (ºC)"}
    //           maxAllowedLine={true}
    //         />
    //       );
    //     case GRAPHS.PERSONS_SCREENED:
    //       let dateData = DataConverter.convertToLineScreenedChartsData(data);
    //       return (
    //         <LineGraphComponent
    //           graphData={dateData}
    //           graph={"rotate"}
    //           xLabel={"Date"}
    //           yLabel={"Number of Persons"}
    //           maxAllowedLine={false}
    //         />
    //       );
    //     case GRAPHS.DAILY_TEMPERATURE:
    //       let temperatureData = DataConverter.convertToLineTemperatureChartsData(
    //         data
    //       );
    //       return <AreaLineComponent graphData={temperatureData} />;
    //     default:
    //       return <div> Oops something wrong</div>;
    //   }
    // }
  };
  render() {
    const { open, handleClose, graphObject, classes, renderStatisticTable } =
      this.props;
    return (
      <React.Fragment>
        <Dialog
          open={open}
          keepMounted={true}
          onClose={() => handleClose()}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          fullScreen={true}
          maxWidth={"md"}
        >
          <CssBaseline />
          <ThemeProvider theme={defaultTheme}>
            <AppBar position="fixed" className={classes.appBar}>
              <Toolbar>
                <Typography variant="h6" className={classes.title}>
                  {this.props.graphObject && this.props.graphObject.title
                    ? this.props.graphObject.title
                    : "Graph Details"}
                </Typography>
                <Button
                  type="submit"
                  onClick={() => handleClose()}
                  color="inherit"
                >
                  <CloseIcon
                    style={{ margin: 10 }}
                    className={classes.extendedIcon}
                  />
                  Close
                </Button>
              </Toolbar>
            </AppBar>
          </ThemeProvider>
          <DialogContent>
            <div
              style={{
                width: "100%",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  flex: 1,
                  padding: "2%",
                  marginTop: "5%",
                  width: "100%",
                  height: "100%",
                }}
              >
                {renderStatisticTable(graphObject.graph)}
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(GraphDetailsDialogV2);
